import notEmpty from '../../core/util/notEmpty';
import searchInFields from '../../core/util/searchInFields';
import type { Bicycle } from '../types';

export const sparePartSearchFields: (keyof Bicycle)[] = [
    'manufacturerName',
    'model',
    'type',
    'id',
    'skuList',
    /* istanbul ignore next -- @preserve */
];

const searchInVehicles = <T>(
    vehicles: T[],
    fields: (keyof T)[],
    search: string
) => {
    return vehicles.filter(vehicle => {
        const fieldsToSearch = fields
            .map(key => {
                const value = vehicle[key];
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                if (value) {
                    if (Array.isArray(value)) {
                        return value.join(' ');
                    }
                    return value;
                }
                return null;
            })
            .filter(notEmpty)
            .join(' ')
            .trim()
            .toLowerCase();

        return searchInFields(fieldsToSearch, search);
    });
};

export default searchInVehicles;
